<template>
    <div>
        <div style="display: flex; justify-content:space-around; align-items: center;">
            <div class="mb-4">
                <button @click.native="changeSearchType(0)" :class="{ 'active': isActive == 0 }">今日</button>
                <button @click.native="changeSearchType(1)" :class="{ 'active': isActive == 1 }">本周</button>
                <button @click.native="changeSearchType(2)" :class="{ 'active': isActive == 2 }">本月</button>
            </div>
            <div style="display: flex; justify-content:space-between; align-items: center;" class="date-time-Infos">
                <a href="#" @click="updateSelectDate(-1)">上一日</a>
                <p v-if="isActive == 0"> {{ selectDate }}</p>
                <p v-if="isActive != 0">{{ startDate }}~{{ selectDate }}</p>
                <a href="#" @click="updateSelectDate(1)">下一日</a>
            </div>
        </div>
        <Section></Section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: 0,
            nowDate: '',
            nowMonth: '',
            selectDate: '',
            startDate: '',
        }
    },
    methods: {
        changeSearchType(searchtype) {
            this.isActive = searchtype;
            // this.$emit("changeType", {type: searchtype, date: this.selectDate});
            this.updateRouter();
        },
        nowDay() {
            const now = new Date();

            const year = now.getFullYear();
            const month = ('0' + (now.getMonth() + 1)).slice(-2);
            const day = ('0' + now.getDate(now.setDate(now.getDate() - 1))).slice(-2);
            const formattedTime = year + "-" + month + "-" + day;
            return [formattedTime, month];
        },
        getNextDate(date, day) {
            var dd = new Date(date);
            dd.setDate(dd.getDate() + day);
            var y = dd.getFullYear();
            var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
            var d = dd.getDate < 10 ? "0" + dd.getDate() : dd.getDate();
            // console.log(y + '年' + m + '月' + d + '日');
            return y + '-' + m + '-' + d;
        },
        updateSelectDate(date) {
            this.selectDate = this.getNextDate(this.selectDate, date);
            // console.log('selectDate:' + this.selectDate);
            this.updateRouter();
        },
        updateStartDate() {
            if (this.isActive == 1) {
                this.startDate = this.getNextDate(this.selectDate, -7);
            }
            else if (this.isActive == 2) {
                this.startDate = this.getNextDate(this.selectDate, -30);
            }
        },

        updateRouter() {
            this.$router.push({
                path: '/rank',
                query: {
                    type: this.isActive,
                    date: this.selectDate,
                }
            })
        }
    },
    created() {
        this.isActive = this.$route.query.type;
        [this.nowDate, this.nowMonth] = this.nowDay();
        this.selectDate = this.nowDate;
        this.startDate = this.getNextDate(this.selectDate, -7);
    },
    watch: {
        selectDate(ne, ol) {
            this.updateStartDate();
        },
        isActive() {
            this.updateStartDate();
        }
    }
}
</script>

<style>
.active {
    color: white;
    background-color: deepskyblue;
}

.date-time-Infos>* {
    margin: 10px;
}
</style>